import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { BannerImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/bannerImpression.trackingInfo";
import { getJsonPayload } from "@omni/utils/dom.utils";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: BannerImpressionTrackingInfo) => {
    const event: AnalyticsEvent<BannerImpressionTrackingInfo> = {
        event: EventType.BannerImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackElement = (element: HTMLElement) => {
    const trackingInfo = getJsonPayload(element);

    track(trackingInfo);
};
